export default "__VITE_ASSET__CAm0OF5z__"